// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"135":"3830c4b0","936":"0a76e65a"}[chunkId] + ".css";
};